import React from "react";

export default function Copy({
  size = 12,
  ...rest
}: {
  size?: number;
  [x: string]: any;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.375C0 3.61561 0.671573 3 1.5 3H7.5C8.32843 3 9 3.61561 9 4.375V12.625C9 13.3844 8.32843 14 7.5 14H1.5C0.671573 14 0 13.3844 0 12.625V4.375ZM1.5 3.91667C1.22386 3.91667 1 4.12187 1 4.375V12.625C1 12.8781 1.22386 13.0833 1.5 13.0833H7.5C7.77614 13.0833 8 12.8781 8 12.625V4.375C8 4.12187 7.77614 3.91667 7.5 3.91667H1.5Z"
        fill="#EBEBEC"
      />
      <path
        d="M3.5 1.40909C3.5 0.907014 3.94772 0.5 4.5 0.5H10.5C11.0523 0.5 11.5 0.907014 11.5 1.40909V9.59091C11.5 10.093 11.0523 10.5 10.5 10.5H4.5C3.94772 10.5 3.5 10.093 3.5 9.59091V1.40909Z"
        fill="#181A1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 1.375C3 0.615608 3.67157 0 4.5 0H10.5C11.3284 0 12 0.615609 12 1.375V9.625C12 10.3844 11.3284 11 10.5 11H4.5C3.67157 11 3 10.3844 3 9.625V1.375ZM4.5 0.916667C4.22386 0.916667 4 1.12187 4 1.375V9.625C4 9.87813 4.22386 10.0833 4.5 10.0833H10.5C10.7761 10.0833 11 9.87813 11 9.625V1.375C11 1.12187 10.7761 0.916667 10.5 0.916667H4.5Z"
        fill="#EBEBEC"
      />
    </svg>
  );
}
